import React from "react";

/**
 * @component EstimatePlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <EstimatePlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EstimatePlusIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="EstimatePlusIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10 0 .338-.017.672-.05 1.001L20 13v-1a8 8 0 10-8 8h1l.001 1.95c-.33.033-.663.05-1.001.05-5.523 0-10-4.477-10-10S6.477 2 12 2zm7 12v3h3v2h-3v3h-2v-3.001L14 19v-2l3-.001V14h2zm-7-8a6 6 0 016 6h-2a4 4 0 10-4 4v2a6 6 0 010-12zm0 4a2 2 0 110 4 2 2 0 010-4z"
      />
    </svg>
  )
);
EstimatePlusIcon.displayName = "EstimatePlusIcon";
export default EstimatePlusIcon;
